module.exports = __webpack_public_path__ + "img/feedback-success.6a857de7.png";